import { CultureInfo } from '../culture-info.model';
import { CultureInfoEn } from './en';

/**
 * @ignore
 */
export const CultureInfoEnMM: CultureInfo = {
  name: 'en-MM',
  displayName: 'English (Myanmar [Burma])',
  iso3LanguageCode: 'eng',
  iso2LanguageCode: 'en',
  ietfLanguageTag: 'en-MM',
  parent: CultureInfoEn
};
